import { useState } from 'react';
import SectionLabel from '../ui/SectionLabel';
import SectionTitle from '../ui/SectionTitle';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import { useAppContext } from '../../context/AppContext';
import { LandingTrans } from '../../utils/translations';
import MyPhoto from '../../assets/photos/19.jpg';

export default function AboutSection() {
  const { language } = useAppContext();
  const t = LandingTrans[language];
  const [ref, visible] = useScrollReveal();
  const [imageError, setImageError] = useState(false);

  return (
    <section
      ref={ref}
      className={`bg-cream py-16 md:py-30 px-6 md:px-20 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
    >
      <div className="grid grid-cols-1 md:grid-cols-[1fr_2fr] gap-12 md:gap-20 max-w-6xl mx-auto">
        <div className="md:sticky md:top-30 order-2 md:order-1">
          <div className="aspect-[3/4] bg-sand rounded-sm overflow-hidden relative">
            {!imageError ? (
              <img
                src={MyPhoto}
                alt={t.anyaAlt}
                className="w-full h-full object-cover"
                onError={() => setImageError(true)}
              />
            ) : null}
            {imageError && (
              <div className="absolute inset-0 bg-gradient-to-b from-clay-light to-sand flex items-end justify-start p-6">
                <span className="font-serif italic text-white text-lg">Anya Joy</span>
              </div>
            )}
          </div>
        </div>

        <div className="order-1 md:order-2">
          <SectionLabel>{t.aboutLabel}</SectionLabel>
          <SectionTitle className="mt-4 mb-6">
            <em className="italic text-clay">{t.aboutTitleEm}</em>{t.aboutTitle}
          </SectionTitle>
          <p className="text-base font-sans font-light text-ink-mid mb-6">
            {t.aboutP1}
          </p>
          <div className="bg-warm-white p-4 rounded-sm mb-6">
            <p className="font-serif text-xl text-brown font-normal italic text-clay leading-relaxed" style={{ lineHeight: 1.5 }}>
              {t.aboutQuote}
            </p>
          </div>
          <p className="text-base font-sans font-light text-ink-mid mb-6">
            {t.aboutP2}
          </p>
          <p className="text-base font-sans font-light text-ink-mid mb-6">
            {t.aboutP3}
          </p>
          <p className="font-serif italic text-clay">
            {t.hippieQuote}
          </p>
        </div>
      </div>
    </section>
  );
}
